/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  HistoricoControllerLinhaDoTempoParams,
  LinhaDoTempoResponse,
  ResumoDoHistoricoResponse,
  SerieDoAnalitoResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHistoricoControllerResumoUrl = (pacienteId: string,) => {




  return `/v1/historico/pacientes/${pacienteId}`
}

/**
 * @summary Resumo do paciente, contagens por tipo e os analitos já medidos
 */
export const historicoControllerResumo = async (pacienteId: string, options?: Parameters<typeof httpClient>[1]): Promise<ResumoDoHistoricoResponse> => {

  return httpClient<ResumoDoHistoricoResponse>(getHistoricoControllerResumoUrl(pacienteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHistoricoControllerResumoQueryKey = (pacienteId: string,) => {
    return [
    `/v1/historico/pacientes/${pacienteId}`
    ] as const;
    }


export const getHistoricoControllerResumoQueryOptions = <TData = Awaited<ReturnType<typeof historicoControllerResumo>>, TError = ErroResponse>(pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHistoricoControllerResumoQueryKey(pacienteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof historicoControllerResumo>>> = ({ signal }) => historicoControllerResumo(pacienteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pacienteId !== null && pacienteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof historicoControllerResumo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HistoricoControllerResumoQueryResult = NonNullable<Awaited<ReturnType<typeof historicoControllerResumo>>>
export type HistoricoControllerResumoQueryError = ErroResponse


export function useHistoricoControllerResumo<TData = Awaited<ReturnType<typeof historicoControllerResumo>>, TError = ErroResponse>(
 pacienteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerResumo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof historicoControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof historicoControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHistoricoControllerResumo<TData = Awaited<ReturnType<typeof historicoControllerResumo>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerResumo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof historicoControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof historicoControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHistoricoControllerResumo<TData = Awaited<ReturnType<typeof historicoControllerResumo>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resumo do paciente, contagens por tipo e os analitos já medidos
 */

export function useHistoricoControllerResumo<TData = Awaited<ReturnType<typeof historicoControllerResumo>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHistoricoControllerResumoQueryOptions(pacienteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHistoricoControllerLinhaDoTempoUrl = (pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/historico/pacientes/${pacienteId}/linha-do-tempo?${stringifiedParams}` : `/v1/historico/pacientes/${pacienteId}/linha-do-tempo`
}

/**
 * @summary Exames, prontuários, requisições e receituários numa lista só. Paginação por cursor de data.
 */
export const historicoControllerLinhaDoTempo = async (pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams, options?: Parameters<typeof httpClient>[1]): Promise<LinhaDoTempoResponse> => {

  return httpClient<LinhaDoTempoResponse>(getHistoricoControllerLinhaDoTempoUrl(pacienteId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHistoricoControllerLinhaDoTempoQueryKey = (pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams,) => {
    return [
    `/v1/historico/pacientes/${pacienteId}/linha-do-tempo`, ...(params ? [params] : [])
    ] as const;
    }


export const getHistoricoControllerLinhaDoTempoQueryOptions = <TData = Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError = ErroResponse>(pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHistoricoControllerLinhaDoTempoQueryKey(pacienteId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>> = ({ signal }) => historicoControllerLinhaDoTempo(pacienteId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pacienteId !== null && pacienteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HistoricoControllerLinhaDoTempoQueryResult = NonNullable<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>>
export type HistoricoControllerLinhaDoTempoQueryError = ErroResponse


export function useHistoricoControllerLinhaDoTempo<TData = Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError = ErroResponse>(
 pacienteId: string,
    params: undefined |  HistoricoControllerLinhaDoTempoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>,
          TError,
          Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHistoricoControllerLinhaDoTempo<TData = Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError = ErroResponse>(
 pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>,
          TError,
          Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHistoricoControllerLinhaDoTempo<TData = Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError = ErroResponse>(
 pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exames, prontuários, requisições e receituários numa lista só. Paginação por cursor de data.
 */

export function useHistoricoControllerLinhaDoTempo<TData = Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError = ErroResponse>(
 pacienteId: string,
    params?: HistoricoControllerLinhaDoTempoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerLinhaDoTempo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHistoricoControllerLinhaDoTempoQueryOptions(pacienteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHistoricoControllerSerieUrl = (pacienteId: string,
    analitoId: string,) => {




  return `/v1/historico/pacientes/${pacienteId}/analitos/${analitoId}`
}

/**
 * @summary Série de um analito com a faixa de referência atual e a variação entre medições
 */
export const historicoControllerSerie = async (pacienteId: string,
    analitoId: string, options?: Parameters<typeof httpClient>[1]): Promise<SerieDoAnalitoResponse> => {

  return httpClient<SerieDoAnalitoResponse>(getHistoricoControllerSerieUrl(pacienteId,analitoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHistoricoControllerSerieQueryKey = (pacienteId: string,
    analitoId: string,) => {
    return [
    `/v1/historico/pacientes/${pacienteId}/analitos/${analitoId}`
    ] as const;
    }


export const getHistoricoControllerSerieQueryOptions = <TData = Awaited<ReturnType<typeof historicoControllerSerie>>, TError = ErroResponse>(pacienteId: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerSerie>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHistoricoControllerSerieQueryKey(pacienteId,analitoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof historicoControllerSerie>>> = ({ signal }) => historicoControllerSerie(pacienteId,analitoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pacienteId !== null && pacienteId !== undefined && analitoId !== null && analitoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof historicoControllerSerie>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HistoricoControllerSerieQueryResult = NonNullable<Awaited<ReturnType<typeof historicoControllerSerie>>>
export type HistoricoControllerSerieQueryError = ErroResponse


export function useHistoricoControllerSerie<TData = Awaited<ReturnType<typeof historicoControllerSerie>>, TError = ErroResponse>(
 pacienteId: string,
    analitoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerSerie>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof historicoControllerSerie>>,
          TError,
          Awaited<ReturnType<typeof historicoControllerSerie>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHistoricoControllerSerie<TData = Awaited<ReturnType<typeof historicoControllerSerie>>, TError = ErroResponse>(
 pacienteId: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerSerie>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof historicoControllerSerie>>,
          TError,
          Awaited<ReturnType<typeof historicoControllerSerie>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHistoricoControllerSerie<TData = Awaited<ReturnType<typeof historicoControllerSerie>>, TError = ErroResponse>(
 pacienteId: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerSerie>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Série de um analito com a faixa de referência atual e a variação entre medições
 */

export function useHistoricoControllerSerie<TData = Awaited<ReturnType<typeof historicoControllerSerie>>, TError = ErroResponse>(
 pacienteId: string,
    analitoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof historicoControllerSerie>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHistoricoControllerSerieQueryOptions(pacienteId,analitoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






